import { useState } from 'react'
import { useInstanzLogo, useInstanzLogoDunkel } from '../lib/instanz'

/**
 * Kundenlogo auf dem Anmeldeschirm, unter Zeichen und Schriftzug (wie im
 * Portal, Alex 12.10., Bilder 130301/130304). Meldet die Instanz keines
 * oder lädt das Bild nicht, steht hier nichts.
 */
export function KundenLogo() {
  const hell = useInstanzLogo()
  const dunkel = useInstanzLogoDunkel()
  const [kaputt, setKaputt] = useState<string[]>([])
  const bild = (src: string, art?: 'hell' | 'dunkel') => (kaputt.includes(src) ? null : (
    <img className={`login-kundenlogo${art ? ` login-kundenlogo-${art}` : ''}`} src={src} alt=""
      onError={() => setKaputt((k) => [...k, src])} />
  ))
  if (!hell) return null
  if (!dunkel || kaputt.includes(dunkel)) return bild(hell)
  return <>{bild(hell, 'hell')}{bild(dunkel, 'dunkel')}</>
}
